import { useEffect, useRef } from "react";
import { PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { cn } from "@/lib/utils";
import { useSidebar } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

export function CustomSidebarTrigger({ className }: { className?: string }) {
  const triggerRef = useRef<HTMLButtonElement>(null);
  const { open, toggleSidebar } = useSidebar();

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", String(!open));
  }, [open]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (
        event.target instanceof HTMLInputElement ||
        event.target instanceof HTMLTextAreaElement
      ) {
        return;
      }

      if (event.key === "[") {
        triggerRef.current?.click();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="flex items-center justify-between px-2 pt-2 group-data-[collapsible=icon]:px-0">
      {open && (
        <div className="flex items-center gap-2">
          <img src={logo} alt="" className="h-6 w-6 rounded-md" />
          <p className="text-lg font-bold">everystreet.run</p>
        </div>
      )}
      <Button
        ref={triggerRef}
        data-sidebar="trigger"
        variant="ghost"
        size="icon"
        className={cn("size-8", className)}
        onClick={toggleSidebar}
      >
        {open ? (
          <PanelLeftClose className="size-4" />
        ) : (
          <PanelLeftOpen className="size-4" />
        )}
      </Button>
    </div>
  );
}
